import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Form, Col } from 'react-bootstrap';
import Button from '../../../../components/Button';
import If from '../../../../components/If';
import AlertError from '../../../../components/AlertError';
import AlertSuccess from '../../../../components/AlertSuccess';
import ResponseError from '../../../../components/ResponseError';
import { STRINGS } from '../../../../util/strings';
import { EventsForm } from '../../../../models/models';
import api from '../../../../services/api';
import '../../styles_add.css';

export default function Events ()
{
	const history = useHistory();
	const [successfulResponse, setSuccessfulResponse] = useState<boolean>(false);
	const [loading, setLoading] = useState<boolean>(false);
	const [error, setError] = useState<any>(null);

	const eventsSchema = yup.object().shape({
		name: yup
			.string()
			.required(STRINGS.FORM_FIELD_REQUIRED),
		active: yup
			.boolean()
	})

	const initialValues: EventsForm = {
		name: '',
		active: true
	}

	const { register, errors, handleSubmit, reset } = useForm({
		defaultValues: initialValues,
		mode: 'onTouched',
		resolver: yupResolver(eventsSchema)
	});

	const verifyErrorsOnForm = (): boolean => {
		if (errors.name) {
			return true;
		}
		return false;
	}

	const onSubmit = async (eventData: EventsForm) => {
		setLoading(true);
		setError(null);
		try {
			const { status } = await api.post('api/v1/cultivares/Evento', {
				nomeEvento: eventData.name,
				ativo: eventData.active
			});

			if (status === 201) {
				setSuccessfulResponse(true);
				reset({
					name: ''
				});
				setTimeout(() => {
					history.goBack();
				}, 3000);
			}
		} catch (error:any) {
			setError(error.response.data);
		}
		setLoading(false);
	}

	return <div className="container container-fluid">
		<If condition={verifyErrorsOnForm()}>
			<AlertError
				message={STRINGS.ALERT_WARNING_FIELDS}
			/>
		</If>
		<If condition={successfulResponse && !error}>
			<AlertSuccess
				message={STRINGS.ALERT_MESSAGE_SUCCESS}
			/>
		</If>
		<If condition={!successfulResponse && error !== null}>
			{error !== null && error.message.length > 0 ? error.message.map((errorE: string) => <AlertError message={errorE} />) : <AlertError message={STRINGS.ALERT_GENERIC_ERROR} />}
		</If>
		<h3>Cadastro de Eventos</h3>
		<Form onSubmit={handleSubmit(onSubmit)}>
			<Form.Row className="row-custom">
				<Form.Group as={Col}>
					<Form.Label>
						Nome do evento<em>*</em>
					</Form.Label>
					<Form.Control
						ref={register}
						name="name"
						as="textarea"
						placeholder="Insira o nome do evento"
						isInvalid={errors.name !== undefined}
						autoComplete="off"
						maxLength={500}
					/>
					<If condition={errors.name}>
						<Form.Control.Feedback type="invalid">
							{errors.name?.message}
						</Form.Control.Feedback>
					</If>
				</Form.Group>
			</Form.Row>
			<Form.Row className="row-custom">
				&nbsp;&nbsp;
				<Form.Group className="checkbox-forms">
					<Form.Check
						type="checkbox"
						ref={register}
						name="active"
						label="Ativo?"
					/>
				</Form.Group>
			</Form.Row>
			<div className="button-position">
				<Button
					title="Cancelar"
					type="button"
					contained={false}
					onClick={() => history.goBack()}
				/>
				<Button
					title="Cadastrar"
					type="submit"
					contained={true}
					isLoading={loading}
				/>
			</div>
		</Form>
	</div >;
}